import React from 'react'

import Image, { StaticImageData } from 'next/image'

import { PaddingProps } from 'styled-system'

import { StyledLink } from './styles'

type Props = PaddingProps & {
  alt?: string
  image: StaticImageData
  href?: string
}

function SuccessBadge({ alt = '', image, href }: Props) {
  return (
    <StyledLink href={href} rel="noopener noreferrer" target="_blank">
      <Image alt={alt} fill src={image} />
    </StyledLink>
  )
}

export default SuccessBadge
